import React from 'react';

type Props = {
  concernTitle?: string;
  showAll: boolean;
  canToggleViewAll: boolean;
  onToggleShowAll: () => void;
};

const RecommendedTreatmentsHeader = ({
  concernTitle,
  showAll,
  canToggleViewAll,
  onToggleShowAll,
}: Props) => {
  return (
    <>
      <div className="mt-8 flex w-full items-center justify-start md:mt-10 md:justify-center">
        <h3 className="text-h2 text-theme-navy-mid">Recommended Services</h3>
      </div>

      <div className="my-6 hidden items-center justify-between md:flex">
        <p className="text-theme-primary text-2xl font-bold">{concernTitle}</p>

        {canToggleViewAll ? (
          <button
            type="button"
            onClick={onToggleShowAll}
            className="text-theme-primary hidden cursor-pointer text-lg font-bold underline md:inline-block"
          >
            {showAll ? 'Show Less' : 'View All Services'}
          </button>
        ) : null}
      </div>
    </>
  );
};

export default RecommendedTreatmentsHeader;
